import { jsx as _jsx } from "react/jsx-runtime";
const ChevronRightFlat = () => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M6.35001 14.21L5.51001 13.65L9.28001 7.99999L5.51001 2.34999L6.35001 1.78999L10.48 7.99999L6.35001 14.21Z" }) })));
ChevronRightFlat.iconName = "chevron_right_flat";
ChevronRightFlat.iconCategory = "Arrows";
export default ChevronRightFlat;
